










































import axios from 'axios';
import env from '@/env';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class CreateModuleDialog extends Vue {
  @Prop()
  cutoverplanId?: number;

  @Prop()
  inList?: boolean;

  dialog = false;

  newName = '';

  newDescription = '';

  newSAP = false;

  @Watch('dialog')
  onToggle(value: boolean) {
    if (value) this.$emit('open');
  }

  async createModule() {
    this.dialog = false;
    const { data } = await axios.post(`${env.backend_url}/module/create`, {
      is_blueprint: !this.cutoverplanId,
      cutoverplan_id: this.cutoverplanId,
      name: this.newName,
      description: this.newDescription,
      sap: this.newSAP
    });
    this.$store.commit('addModuleToModuleIdsToNameMap', { id: data.id, name: this.newName });
    if (this.cutoverplanId) {
      await this.$router.push({ path: `/cutoverplan/${this.cutoverplanId}/module/${data.id}` });
    } else {
      await this.$router.push({ path: `/blueprints/${data.id}` });
    }
  }
}
